import React, { useEffect, useState } from 'react';
import {
    ACCOUNT_TYPE_TO_DISPLAY,
    AD_ENTITY_TYPES,
    ENTITY_SELECTOR_FILTER_TYPES
} from '@silverfort-nodelibs/common/utils/consts';
import FiltersContainer from './FiltersContainer';
import SearchTable from './SearchTable';

import styles from './css/SearchContainer.module.css';
import SelectField from '../../../SystemSettings/components/Controls/SelectField/SelectField';

const ONLY_LOCAL_ACCOUNT_TYPES = [ACCOUNT_TYPE_TO_DISPLAY.DISPLAY_NAME, ACCOUNT_TYPE_TO_DISPLAY.DEVICE_NAME];
const NOT_LOCAL_ACCOUNT_TYPES = [
    ACCOUNT_TYPE_TO_DISPLAY.DISPLAY_NAME,
    ACCOUNT_TYPE_TO_DISPLAY.FULL_PATH,
    ACCOUNT_TYPE_TO_DISPLAY.SAM_ACCOUNT
];

const getAccountTypesOptions = (selectorType, currentFilterType) => {
    const defaultAccountTypeOption = ACCOUNT_TYPE_TO_DISPLAY.DISPLAY_NAME;
    const totalOptions = Object.values(ACCOUNT_TYPE_TO_DISPLAY);

    if (selectorType.searchEntitiesTypes?.includes(AD_ENTITY_TYPES.LOCAL_ACCOUNT)) {
        if (currentFilterType === ENTITY_SELECTOR_FILTER_TYPES.LOCALS_ONLY.value) {
            return {
                accountTypesOptions: ONLY_LOCAL_ACCOUNT_TYPES,
                defaultAccountTypeOption
            };
        }
        if (currentFilterType !== ENTITY_SELECTOR_FILTER_TYPES.ALL.value) {
            return {
                accountTypesOptions: NOT_LOCAL_ACCOUNT_TYPES,
                defaultAccountTypeOption
            };
        }
        return {
            accountTypesOptions: totalOptions,
            defaultAccountTypeOption
        };
    }

    const accountTypesOptions = totalOptions.filter(
        (option) => option.value !== ACCOUNT_TYPE_TO_DISPLAY.DEVICE_NAME.value
    );
    return { accountTypesOptions, defaultAccountTypeOption };
};

const SearchContainer = ({
    selectorData,
    onSelectSuggestion,
    showExcluded,
    disableAdd = false,
    focusedResource,
    currentSelectedEntities,
    selectAllEntities,
    onSelectAllEntitiesClicked,
    allowSelectAll,
    selectAllText,
    isMaxEntitiesReached,
    alwaysSearch,
    allowChangeDisplayAccountType,
    authTypes,
    searchTableClassName = '',
    showUnresolvedResources = false
}) => {
    const [suggestions, setSuggestions] = useState([]);
    const [suggestionsQuery, setSuggestionsQuery] = useState('');
    const [currentFilterType, setCurrentFilterType] = useState(ENTITY_SELECTOR_FILTER_TYPES.ALL.value);
    const { accountTypesOptions, defaultAccountTypeOption } = getAccountTypesOptions(selectorData, currentFilterType);
    const [accountTypeToDisplay, setAccountTypeToDisplay] = useState(defaultAccountTypeOption);

    useEffect(() => {
        const { accountTypesOptions, defaultAccountTypeOption } = getAccountTypesOptions(
            selectorData,
            currentFilterType
        );
        if (!accountTypesOptions.map(({ value }) => value).includes(accountTypeToDisplay.value)) {
            setAccountTypeToDisplay(defaultAccountTypeOption);
        }
    }, [selectorData, accountTypeToDisplay, currentFilterType]);

    const onSuggestionsQueryChanged = (newValue) => {
        if (newValue === '' && !alwaysSearch) {
            setSuggestions([]);
        }
        setSuggestionsQuery(newValue);
    };
    const onAccountTypeToDisplayChanged = (id, value) => {
        setAccountTypeToDisplay(accountTypesOptions.find((o) => o.value === value));
    };

    let searchEntitiesTypes = selectorData.searchEntitiesTypes;
    if (currentFilterType !== ENTITY_SELECTOR_FILTER_TYPES.ALL.value) {
        const filterObj = Object.values(ENTITY_SELECTOR_FILTER_TYPES).find(
            (filterTye) => filterTye.value === currentFilterType
        );
        if (filterObj) {
            searchEntitiesTypes = filterObj.searchEntitiesTypes || [];
        }
    }

    return (
        <div className={styles.searchContainer}>
            <FiltersContainer
                filtersOptions={selectorData.filters}
                currentFilterType={currentFilterType}
                setCurrentFilterType={setCurrentFilterType}
            />
            <div>
                {allowChangeDisplayAccountType && (
                    <div>
                        <div className={styles.displayAccountTypeTitle}> Account identifier :</div>
                        <div className={styles.changeDisplayAccountType}>
                            {' '}
                            <SelectField
                                field={accountTypeToDisplay}
                                changed={onAccountTypeToDisplayChanged}
                                options={accountTypesOptions}
                            />
                        </div>
                    </div>
                )}
            </div>
            <div className={styles.checkzboxesContainer}>
                {onSelectAllEntitiesClicked && (
                    <div key="selectAllCheckBox" className={`sfcheckbox ${styles.checkboxContainer}`}>
                        <input
                            id={`selectAllCheckBox`}
                            type="checkbox"
                            onChange={(e) => {
                                onSelectAllEntitiesClicked(e.target.checked);
                            }}
                            checked={selectAllEntities}
                            disabled={!allowSelectAll && !selectAllEntities}
                        />
                        <label className="checkboxLabel" htmlFor={'selectAllCheckBox'}>
                            {`Select all ${selectAllText}`}
                        </label>
                    </div>
                )}
            </div>

            <SearchTable
                suggestions={suggestions}
                suggestionsQuery={suggestionsQuery}
                placeholderText={selectorData.placeholderText}
                onSuggestionsQueryChanged={onSuggestionsQueryChanged}
                onSelectSuggestion={onSelectSuggestion}
                showExcluded={showExcluded}
                disableAdd={disableAdd}
                searchEntitiesTypes={searchEntitiesTypes}
                setSuggestions={setSuggestions}
                focusedResource={focusedResource}
                currentSelectedEntities={currentSelectedEntities}
                selectAllEntities={selectAllEntities}
                disabled={isMaxEntitiesReached}
                alwaysSearch={alwaysSearch}
                accountTypeToDisplay={accountTypeToDisplay.value}
                authTypes={authTypes}
                searchTableClassName={searchTableClassName}
                showUnresolvedResources={showUnresolvedResources}
            />
        </div>
    );
};

export default SearchContainer;
